export enum MediaPageLocation {
  allMedia = 'allMedia',
  intervention = 'intervention',
  mediaSelect = 'mediaSelect',
}
